/*
 * 百舸云平台权限配置 - 企业客户权限
 *
 * name                     应用名称
 * version                  应用版本  1.0.0 开始
 * menus                    全部菜单  Array
 *   name                   菜单标识
 *   title                  菜单名称
 *   views                  二级菜单
 *     pc                   pc端  Array
 *       name               菜单标识
 *       title              菜单名称
 *       haveMenuSubpage    一级菜单有子页面
 *       auth               功能权限
 *         name             权限名称
 *         permission       权限值  菜单标识_菜单标识_功能
 *         haveSubpage      二级菜单有子页面
 *         pages            子页面标识  Array
 *
 *     mobile               移动端  Array
 */

export default {
  name: 'BaiGeYun',
  version: '1.0.0',
  menus: [
    {
      name: 'overview',
      title: '概况总览',
      views: {
        pc: [
          {
            name: 'overview',
            title: '概况总览',
            auth: [
              {
                name: '查看',
                permission: 'overview_overview_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'equipmentCenter',
      title: '设备中心',
      views: {
        pc: [
          {
            name: 'deviceManage',
            title: '设备管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'equipmentCenter_deviceManage_view',
                haveSubpage: true,
                pages: ['deviceDetail']
              }
            ]
          },
          {
            name: 'productLineManage',
            title: '产线管理',
            auth: [
              {
                name: '查看',
                permission: 'equipmentCenter_productLineManage_view',
                haveSubpage: true,
                pages: ['productLineDetail']
              }
            ]
          },
          {
            name: 'deviceGroup',
            title: '设备分组',
            auth: [
              {
                name: '查看',
                permission: 'equipmentCenter_deviceGroup_view'
              },
              {
                name: '自定义分组管理',
                permission: 'equipmentCenter_deviceGroup_customerGroup'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'gatewayManage',
      title: '网关管理',
      views: {
        pc: [
          {
            name: 'gatewayManage',
            title: '网关管理',
            haveMenuSubpage: true,
            auth: [
              {
                name: '查看 / 详情',
                permission: 'gatewayManage_gatewayManage_view',
                haveSubpage: true,
                pages: ['gatewayDetail']
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'organizationManage',
      title: '组织机构',
      views: {
        pc: [
          {
            name: 'companyManage',
            title: '企业管理',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_companyManage_view'
              },
              {
                name: '修改',
                permission: 'organizationManage_companyManage_modify'
              }
            ]
          },
          {
            name: 'userManage',
            title: '用户管理',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_userManage_view'
              },
              {
                name: '新增部门 / 编辑部门',
                permission: 'organizationManage_userManage_addAndModifyOrganization'
              },
              {
                name: '删除部门',
                permission: 'organizationManage_userManage_deleteOrganization'
              },
              {
                name: '用户账号管理',
                permission: 'organizationManage_userManage_userAccountManage'
              },
              {
                name: '授权设备 / 取消授权',
                permission: 'organizationManage_userManage_onAndOffDevice'
              }
            ]
          },
          {
            name: 'roleManage',
            title: '角色管理',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_roleManage_view'
              },
              {
                name: '新增角色 / 编辑角色',
                permission: 'organizationManage_roleManage_addAndModify',
                haveSubpage: true,
                pages: ['addOrModifyRole']
              },
              {
                name: '推送设置',
                permission: 'organizationManage_roleManage_pushSet'
              },
              {
                name: '启用 / 禁用',
                permission: 'organizationManage_roleManage_onAndOff'
              },
              {
                name: '删除',
                permission: 'organizationManage_roleManage_delete'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'dataLargeScreen',
      title: '数据大屏',
      views: {
        pc: [
          {
            name: 'my',
            title: '我的大屏',
            auth: [
              {
                name: '查看',
                permission: 'dataLargeScreen_my_view'
              },
              {
                name: '操作',
                permission: 'dataLargeScreen_my_operate'
              }
            ]
          },
          {
            name: 'template',
            title: '模板中心',
            auth: [
              {
                name: '查看',
                permission: 'dataLargeScreen_template_view'
              }
            ]
          },
          {
            name: 'dataSource',
            title: '数据源',
            auth: [
              {
                name: '查看',
                permission: 'dataLargeScreen_dataSource_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'smsManageForCustomer',
      title: '短信管理',
      views: {
        pc: [
          {
            name: 'smsManageForCustomer',
            title: '短信管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'smsManageForCustomer_smsManageForCustomer_view'
              },
              {
                name: '预警设置',
                permission: 'smsManageForCustomer_smsManageForCustomer_warnSet'
              },
              {
                name: '重新发送',
                permission: 'smsManageForCustomer_smsManageForCustomer_resend'
              },
              {
                name: '购买套餐',
                permission: 'smsManageForCustomer_smsManageForCustomer_buyPackage'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'iotCardManageForCustomer',
      title: '物联卡管理',
      views: {
        pc: [
          {
            name: 'iotCardManageForCustomer',
            title: '物联卡管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'iotCardManageForCustomer_iotCardManageForCustomer_view'
              },
              {
                name: '续费套餐',
                permission: 'iotCardManageForCustomer_iotCardManageForCustomer_rebuy'
              },
              {
                name: '预警设置',
                permission: 'iotCardManageForCustomer_iotCardManageForCustomer_warnSet'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'workorderManage',
      title: '工单管理',
      views: {
        pc: [
          {
            name: 'workorderManage',
            title: '工单管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'workorderManage_workorderManage_view'
              },
              {
                name: '新增工单',
                permission: 'workorderManage_workorderManage_add'
              },
              {
                name: '编辑工单',
                permission: 'workorderManage_workorderManage_edit'
              },
              {
                name: '删除工单',
                permission: 'workorderManage_workorderManage_delete'
              },
              {
                name: '取消工单',
                permission: 'workorderManage_workorderManage_cancel'
              }
            ]
          }
        ],
        mobile: []
      },
    },
    {
      name: 'sendMessage',
      title: '发送消息',
      views: {
        pc: [
          {
            name: 'sendMessage',
            title: '发送消息',
            auth: [
              {
                name: '查看',
                permission: 'sendMessage_sendMessage_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'systemManageForCustomer',
      title: '系统日志',
      views: {
        pc: [
          {
            name: 'systemManageForCustomer',
            title: '系统日志',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'systemManageForCustomer_systemManageForCustomer_view'
              }
            ]
          }
        ],
        mobile: []
      }
    }
    // {
    //   name: 'mobileSetting',
    //   title: '移动端设置',
    //   views: {
    //     pc: [
    //       {
    //         name: 'mobileSetting',
    //         title: '移动端设置',
    //         auth: [
    //           {
    //             name: '查看',
    //             permission: 'mobileSetting_mobileSetting_view'
    //           },
    //           {
    //             name: '基本信息',
    //             permission: 'mobileSetting_mobileSetting_basicSet'
    //           },
    //           {
    //             name: '广告图管理',
    //             permission: 'mobileSetting_mobileSetting_bannerSet'
    //           },
    //           {
    //             name: '关于我们',
    //             permission: 'mobileSetting_mobileSetting_aboutSet'
    //           }
    //         ]
    //       }
    //     ],
    //     mobile: []
    //   }
    // }
  ]
};
